import React, { useState } from 'react';
import { motion } from 'framer-motion';
import FadeIn from './FadeIn';

export default function BeforeAfterDemo({ className = '' }) {
  const [active, setActive] = useState('before');

  return (
    <FadeIn className={className}>
      <div className="flex justify-center gap-2 mb-8">
        {['before', 'after'].map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActive(tab)}
            className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all ${
              active === tab
                ? 'bg-invert-navy text-white'
                : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
            }`}
          >
            {tab === 'before' ? 'The old way' : 'With INVERT'}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
        <motion.div
          animate={{ opacity: active === 'before' ? 1 : 0.4, scale: active === 'before' ? 1 : 0.98 }}
          className="rounded-2xl border border-invert-border p-6 lg:p-8 bg-slate-50"
        >
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-4">
            Before INVERT
          </p>
          <ul className="space-y-3 text-slate-600">
            {[
              'Open Canva or PowerPoint',
              'Hire a designer ($200+)',
              'Resize for every screen',
              'Upload files manually',
              'Schedule in complicated software',
              'Repeat for every promotion',
            ].map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm lg:text-base">
                <span className="text-red-400 mt-0.5">✕</span>
                {item}
              </li>
            ))}
          </ul>
          <div className="mt-6 p-4 bg-white rounded-xl border border-dashed border-slate-300 text-center text-slate-400 text-sm">
            promotion_final_v3.pptx
          </div>
        </motion.div>

        <motion.div
          animate={{ opacity: active === 'after' ? 1 : 0.4, scale: active === 'after' ? 1 : 0.98 }}
          className="rounded-2xl border-2 border-invert-orange/30 p-6 lg:p-8 bg-white shadow-lg"
        >
          <p className="text-xs font-semibold uppercase tracking-wider text-invert-orange mb-4">
            With INVERT
          </p>
          <div className="glass-card-light rounded-xl p-4 mb-4">
            <p className="text-invert-navy font-medium text-lg">
              &ldquo;Happy Hour starts at 4.&rdquo;
            </p>
          </div>
          <ul className="space-y-3 text-invert-navy">
            {[
              'Beautiful typography — automatic',
              'Brand colors applied — automatic',
              'Animations added — automatic',
              'All screens updated — instant',
              'Scheduled — just say when',
            ].map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm lg:text-base">
                <span className="text-green-500 mt-0.5">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </FadeIn>
  );
}
